namespace GeniuzPOS.Common.Models {
    export interface UploadFileResponse extends Serenity.ServiceResponse {
        success?: boolean;
        message?: string;
        Inserted?: number;
        Updated?: number;
        ErrorLists?: Serenity.ServiceError[];
    }
}
